import * as React from "react";
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { CheckIcon } from "lucide-react";

import { cn } from "@/lib/utils";

function Checkbox({
  className,
  ...props
}: React.ComponentProps<typeof CheckboxPrimitive.Root>) {
  return (
    <CheckboxPrimitive.Root
      data-slot="checkbox"
      className={cn(
        // Base styles from Figma Design System
        "aero:peer aero:size-4 aero:shrink-0 aero:rounded-[2.5px]",
        "aero:border aero:border-neutral-500",
        "aero:bg-white",
        "aero:shadow-none aero:transition-all aero:outline-none",
        // Focus state
        "aero:focus-visible:ring-[3px] aero:focus-visible:ring-ring/50 aero:focus-visible:border-ring",
        // Checked state - brand primary colors from Figma
        "aero:data-[state=checked]:bg-brand-primary-50 aero:data-[state=checked]:border-brand-primary-500",
        "aero:data-[state=checked]:text-brand-primary-500",
        // Disabled state
        "aero:disabled:cursor-not-allowed aero:disabled:bg-neutral-200 aero:disabled:border-neutral-500",
        "aero:disabled:data-[state=checked]:bg-neutral-200 aero:disabled:data-[state=checked]:text-neutral-500",
        // Invalid state
        "aero:aria-invalid:border-destructive aero:aria-invalid:ring-destructive/20",
        className
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        data-slot="checkbox-indicator"
        className="aero:flex aero:items-center aero:justify-center aero:text-current"
      >
        <CheckIcon className="aero:size-3.5 aero:stroke-[2.5px]" />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  );
}

export { Checkbox };
